export default __webpack_public_path__ + "locales/sl/EmptyTrashDialog.json?hash=d51c313be49fb8708f6e51c346fcd656";